export default __webpack_public_path__ + "static/media/services-walkways.95262af6.jpg";